import { FILE_FORMATS, type AttachedFile, type AttachmentSettings } from 'framework/files';
import { id } from '../../format/pieces';
import { s, type Schema } from '../../format/schema';

export const attachmentSettings = s.strictObject({
  maxFileSizeMb: s
    .number()
    .refine(mb => mb > 0, 'should be above 0')
    .optional(),
  allowedFormats: s.array(s.enum(FILE_FORMATS)).optional(),
}) satisfies Schema<AttachmentSettings>;

export const attachedFile = s.strictObject({
  fileId: id,
  name: s.string(),
  size: s.number().refine(bytes => Number.isInteger(bytes) && bytes >= 0, 'should be a whole number, 0 or more'),
  mimeType: s.string(),
}) satisfies Schema<AttachedFile>;
